import { z } from 'zod';
/**
 * Replay giả định, có rút bài học — APM-AI-t (`plan-ai-features.md` mục 4).
 *
 * ## Bài học chỉ ghi khi giả định TỐT HƠN rõ rệt
 *
 * Mỗi lần ai đó thử một giả định mà sinh một "bài học" là cách làm cho khái niệm
 * bài học mất nghĩa: sau một tuần, danh sách retro đầy những câu hiển nhiên và
 * không ai đọc nữa. Giả định không tốt hơn thì người dùng **vẫn thấy** kết quả
 * mô phỏng — chỉ là không có gì được ghi lại.
 */
export const WhatIfChange = z.discriminatedUnion('kind', [
    z.object({ kind: z.literal('drop_task'), taskId: z.uuid() }),
    z.object({ kind: z.literal('reassign'), taskId: z.uuid(), assigneeId: z.uuid().nullable() }),
    z.object({ kind: z.literal('add_capacity'), assigneeId: z.uuid(), hoursPerDay: z.number().positive() }),
    z.object({ kind: z.literal('change_estimate'), taskId: z.uuid(), estimateHours: z.number().positive() }),
]);
export const WhatIfOutcome = z.object({
    hypothesis: z.array(WhatIfChange).min(1).max(10),
    /** Mốc tua về. */
    asOf: z.iso.datetime(),
    result: z.object({
        p50ShiftDays: z.number(),
        p85ShiftDays: z.number(),
        tasksAffected: z.number().int().nonnegative(),
        /** Đi kèm để tái dựng con số: cùng seed, cùng giả định ⇒ cùng kết quả. */
        seed: z.number().int().nonnegative(),
    }),
    verdict: z.enum(['better', 'worse', 'same']),
    /** Câu kết luận cho người đọc, nói bằng số. */
    summary: z.string().min(1).max(1_000),
    /** Chỉ có khi `verdict === 'better'`; `finalize()` xoá nó trong mọi trường hợp khác. */
    lesson: z
        .object({
        text: z.string().min(1).max(500),
        /** Khi nào bài học này áp dụng được — không có thì nó là một câu nói chung chung. */
        appliesWhen: z.string().min(1).max(300),
        confidence: z.enum(['low', 'medium', 'high']),
    })
        .nullable(),
});
//# sourceMappingURL=ai-what-if.js.map